import { FiltersToApplyProps } from '../../../hooks/useFilterTransformer';

import { filtersPropMapper } from './constants';

export const execFilter = <T>(dataToFilter: T[], filters: FiltersToApplyProps): T[] => {
  const filtersEntries = Object.entries(filters);

  const searchTermFilters = filtersEntries.filter(([key]) => key.endsWith('SearchTermFilter'));

  const filtersWithDirectApplication = filtersEntries.filter(
    ([key, values]) => !key.includes('Maximum') && !key.includes('Minimum') && Array.isArray(values)
  );

  const complexFilters = filtersEntries.filter(
    ([key]) => key.includes('Maximum') || key.includes('Minimum')
  );

  let dataFiltered = dataToFilter.filter((item) => {
    return filtersWithDirectApplication.every(([key, values]) => {
      if (Array.isArray(values)) {
        const baseKey: string | null = filtersPropMapper[key];
        const value = item[baseKey || key];

        return values.includes(value.toString());
      }

      return true;
    });
  });

  complexFilters.forEach(([key, value]) => {
    const baseKey: string | null = filtersPropMapper[key];
    if (!baseKey) {
      return;
    }
    const isMaximum = key.includes('Maximum');
    const isMinimum = key.includes('Minimum');

    dataFiltered = dataFiltered.filter((item) => {
      if (isMaximum && item[baseKey] > value) {
        return false;
      }
      if (isMinimum && item[baseKey] < value) {
        return false;
      }
      return true;
    });
  });

  searchTermFilters.forEach(([key, value]) => {
    const baseKey = key.replace('SearchTermFilter', '');

    dataFiltered = dataFiltered.filter((item) => {
      if (Array.isArray(value)) {
        const loweredValue = value.map((valueToLower) => valueToLower.toString().toLowerCase());
        return loweredValue.includes(item[baseKey].toLowerCase());
      }

      return item[baseKey].toLowerCase().includes(value.toString().toLowerCase());
    });
  });

  return dataFiltered;
};
